import {Button, Heading, ModalBody, ModalCloseButton, ModalContent, ModalHeader, Text} from '@chakra-ui/react';
import {IModalProps, Modal} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {modalCloseButtonStyles} from 'theme';

interface IProps extends IModalProps {}

export const DeliverySmallOrderFeeModal: FC<IProps> = ({isOpen, onClose}) => {
  const {t} = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent mx={['5px', 0]}>
        <ModalHeader display="flex" alignItems="center" justifyContent="space-between">
          <Heading fontSize={['18px', '22px']} fontWeight="bold">
            {t('smallOrder')}
          </Heading>
          <ModalCloseButton position="static" sx={modalCloseButtonStyles} />
        </ModalHeader>
        <ModalBody px="5" pb="5" m={0}>
          <Text fontWeight={500} fontSize={['12px', '16px']}>
            {t('cartSurchargeDescription')}
          </Text>
          <Button variant="primary" w="full" mt="10px" onClick={onClose}>
            {t('okay')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
